import { orderList } from "@/services/order"
import { vaildCodeMap } from "./orderStatusMap"
const getOrderList = ( self ) => {
    let orderId = self.search
    let page = self.page
    let status = self.status
    let period = self.filter
    let limit = 10
    let data = {orderId,page,status,period,limit }
    self.$showToast({
      type: 'loading',
      toastMessage: '正在加载数据...',
      duration: 2000 
    })
    orderList( data ).then( res => {
        self.hasMore = res.data.hasMore
        // 更新字段对应的值
        if (res.data.orders && res.data.orders.length > 0 ) {
          res.data.orders.forEach( item => {
            item.codeName = vaildCodeMap[item.validCode]
            self.orderList.push( item )
          })
        }
    }).catch(() => {
    })
}
export { getOrderList }